export const environment = {
    production: true,
  
    baseUrl: 'https://mysat.ifma-sat.uatbyopeneyes.com',
    ssoLoginUrl: 'https://loginifmaorg-sandbox.azurewebsites.net/?redirectUrl=',
    ssoLogoutUrl: 'https://loginifmaorg-sandbox.azurewebsites.net/Account/LogOff/?redirectUrl=',
    apiUrl: 'https://api.ifma-sat.uatbyopeneyes.com/public/api',
    connectorUrl: 'https://connector.ifma-sat.uatbyopeneyes.com',
    adminUrl: 'https://admin.ifma-sat.uatbyopeneyes.com',
    CookieDomainUrl: 'ifma-sat.uatbyopeneyes.com',
    authUrl: 'https://sat.ifma-sat.uatbyopeneyes.com',
    cndURL: 'https://assets.ifma-sat.uatbyopeneyes.com/',
    TestMode: false,
    env: 'prod'
  };